<mat-spinner *ngIf="loading" diameter="20" class="spinner"></mat-spinner>
<ng-container *ngIf="!loading">
  <div class="row w-100">
    <div class="col-md-6 col-12 col-sm-12" *ngFor="let plan of plans; let i = index">
      <mat-card
        class="card"
        [ngClass]="[
          selectedPlanId
            ? selectedPlanId == plan['id']
              ? 'selected-card'
              : 'card'
            : activePlanId == plan['id']
            ? 'selected-card'
            : 'card'
        ]"
      >
        <div class="plan-box">
          <div class="plan-box-header">
            <div class="plan-box-header1">
              <h4>{{ plan.product.replace('ValueTest', '') }}</h4>
              <div class="currency-s">
                <span class="currency">{{
                  plan['discountPrice'] ? (plan['discountPrice'] | currency) : (plan['amount'] | currency)
                }}</span
                >{{ plan?.interval == 'month' ? '/Month' : plan?.interval == 'week' ? '/Week' : '/Report' }}
              </div>
            </div>

            <div>
              <button
                class="choose-plan-btn"
                [disabled]="i === 0 && disableTrialPlan"
                [ngClass]="[
                  selectedPlanId
                    ? selectedPlanId == plan['id']
                      ? 'selected-choose-plan-btn'
                      : 'choose-plan-btn'
                    : activePlanId == plan['id']
                    ? 'selected-choose-plan-btn'
                    : 'choose-plan-btn'
                ]"
                (click)="choosePlan(plan['id'])"
              >
                {{
                  activePlanId == plan['id']
                    ? 'Current Plan'
                    : selectedPlanId == plan['id']
                    ? 'Selected Plan'
                    : i === 0 && disableTrialPlan
                    ? 'Trial Expired'
                    : 'Choose Plan'
                }}
              </button>
            </div>
          </div>
          <div class="plan-box-content">
            <ul class="features-list">
              <li *ngFor="let feature of plan?.['features']" class="features">
                <mat-icon class="done-icon">done</mat-icon>
                <span class="feature"
                  >{{ feature.name }}<br /><span
                    class="report-link"
                    *ngIf="
                      feature.name.toLowerCase().includes('report') && feature.name.toLowerCase().includes('mortgage')
                    "
                    (click)="viewSampleReport()"
                    >View Sample Mortgage</span
                  ></span
                >
              </li>
            </ul>
          </div>
          <div class="promotion-code-section" *ngIf="plan?.['offerApplied'] != true && plan.amount ">
            <span>Promo code:</span>
            <span><input type="text" [formControl]="code" placeholder="Enter Promo Code" class="input-class" /></span>
            <span
              ><button (click)="applyCode(plan['id'], i)" class="apply-btn" [disabled]="spin">
                <i class="fa fa-spinner fa-spin" *ngIf="spin && currentIndex == i"> </i>
                Apply
              </button></span
            >
          </div>
          <div class="promotion-code-section" *ngIf="plan?.['offerApplied'] == true">
            <span>{{ plan?.['promoCode'] }} Applied</span>
            <span><button class="apply-btn" (click)="removeCode(plan['id'])">Remove</button></span>
          </div>
          <span class="warning-msg" *ngIf="nextPlanId == plan['id']">
            <mat-icon class="Lo-select">info_outline</mat-icon>
            <p>
              This plan will take effect only after your current subscription. {{ activePlanName }}, ends on
              {{ nextPlanStartDate }}
            </p>
          </span>
        </div>
      </mat-card>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="subscriptionMode === 'bundle'">
  <div class="current-bundle-info" *ngIf="subscriptionMode === 'bundle' && selectedBundles?.length">
    <p><strong>Current Base Plan:</strong> {{ activePlan?.product || activePlanName }}</p>
    <p>
      <strong>Current Bundles:</strong>
      <span *ngFor="let bundle of selectedBundles; let last = last">
        {{ bundle.product }}<span *ngIf="!last">, </span>
      </span>
    </p>
  </div>

  <div class="bundle-section">
    <h3 class="bundle-title">Available Bundles</h3>

    <div class="row w-100">
      <div class="col-md-6 col-12 col-sm-12" *ngFor="let bundle of mandatoryBundles">
        <mat-card class="card selected-card">
          <div class="plan-box">
            <div class="plan-box-header">
              <div class="plan-box-header1">
                <h4>{{ bundle.product }}</h4>
                <div class="currency-s">
                  <span class="currency">{{ bundle.amount | currency }}</span
                  >/Month
                </div>
              </div>
              <div>
                <button class="selected-choose-plan-btn" disabled>Mandatory</button>
              </div>
            </div>

            <div class="plan-box-content">
              <ul class="features-list">
                <li *ngFor="let feature of bundle?.features" class="features">
                  <mat-icon class="done-icon">done</mat-icon>
                  <span class="feature">{{ feature.name }}</span>
                </li>
              </ul>
            </div>
          </div>
        </mat-card>
      </div>

      <div class="col-md-6 col-12 col-sm-12" *ngFor="let bundle of bundlePlans">
        <mat-card class="card" [ngClass]="isBundleSelected(bundle.id) ? 'selected-card' : 'card'">
          <div class="plan-box">
            <div class="plan-box-header">
              <div class="plan-box-header1">
                <h4>{{ bundle.product }}</h4>
                <div class="currency-s">
                  <span class="currency">{{ bundle.amount | currency }}</span
                  >/Month
                </div>
              </div>
              <div>
                <button
                  class="choose-plan-btn"
                  [ngClass]="isBundleSelected(bundle.id) ? 'selected-choose-plan-btn' : 'choose-plan-btn'"
                  (click)="toggleBundle(bundle)"
                >
                  {{ isBundleSelected(bundle.id) ? 'Selected' : 'Select Bundle' }}
                </button>
              </div>
            </div>

            <div class="plan-box-content">
              <ul class="features-list">
                <li *ngFor="let feature of bundle?.features" class="features">
                  <mat-icon class="done-icon">done</mat-icon>
                  <span class="feature">{{ feature.name }}</span>
                </li>
              </ul>
            </div>
          </div>
        </mat-card>
      </div>
    </div>

    <div class="bundle-summary" *ngIf="bundleSummary">
      <p><strong>Bundles Total:</strong> {{ bundleSummary.totalBundleAmount | currency }}</p>
      <p *ngIf="bundleDiscount">
        <strong>Discount:</strong>
        {{ bundleDiscount.value }}% (-{{ bundleSummary.discountAmount | currency }})
      </p>
      <p><strong>Final Bundle Total:</strong> {{ bundleSummary.finalBundleAmount | currency }}</p>
    </div>
  </div>
</ng-container>

<div class="button-section">
  <div class="info-section"></div>
  <button
    mat-flat-button
    color="primary"
    class="save-plan"
    (click)="save()"
    [disabled]="loading"
    *ngIf="userRole != 'appraiser'"
  >
    Save Plan
  </button>
</div>
